import React from "react";
import '../styles.scss';
import './section1.scss';



/**
     * section 1 
     * main video
     * center text
     * 
     *  
     * */

const Section1: React.FC = () => {
  return <>
    <section className="video_cont">
      <video
        id="video_1"
        preload="auto"
        autoPlay
        controlsList="nodownload"
        muted loop
        playsInline
      poster="./assets/images/reel-poster.png"
      >
        <source src="./assets/videos/Trailer.mp4" type="video/mp4" />
        Your browser does not support HTML video.
      </video>

      <div className="dh_logo">
        <img src="./assets/images/Dhyana_Logo_V2_Final.png" />

      </div>

      <div className="dh-video-overlay">
        <div className="dh-video-centerText">
          <p className="mid_p white font_nun_bold">
            Immersive environments that <span className="green_50">calm the mind,</span> ease anxiety, and accelerate recovery.
          </p>
          <p className="scnd_p grey_88 font_nun_reg text-start lh-base ps-1">Where mindfulness meets the infinite possibilities of virtual serenity</p>
        

          {/* <p>Let's learn, enchant &amp; amaze together!</p> */}
        </div>
        {/* <div className="dh-video-centerText dh-bottomText text-start">

        <p className="scnd_p grey_88 font_nun_reg text-center ps-1">Where mindfulness meets the infinite possibilities of virtual serenity</p>
        </div> */}
      </div>
    </section>
  </>;
};

export default Section1;